import mqtt from 'mqtt';

const MQTT_URL = process.env.REACT_APP_MQTT_WS || 'ws://localhost:9001';

class MqttService {
  constructor() {
    this.client = null;
    this.connected = false;
    this.messageCallback = null;
    this.connectCallback = null;
    this.disconnectCallback = null;
  }

  connect(onMessage) {
    this.messageCallback = onMessage;

    // Deshabilitado MQTT en producción - solo usar API REST
    if (MQTT_URL.includes('localhost')) {
      console.log('⚠️  MQTT deshabilitado en producción. Usando solo API REST.');
      return;
    }

    this.client = mqtt.connect(MQTT_URL, {
      clientId: `dashboard-${Math.random().toString(16).substr(2, 8)}`,
      clean: true,
      reconnectPeriod: 5000
    });

    this.client.on('connect', () => {
      console.log('✅ Conectado a MQTT');
      this.connected = true;
      
      // Suscribirse a todos los topics de CAMMESA
      this.client.subscribe('cammesa/#', { qos: 1 }, (err) => {
        if (!err) {
          console.log('📥 Suscrito a cammesa/#');
        }
      });

      if (this.connectCallback) {
        this.connectCallback();
      }
    });

    this.client.on('message', (topic, message) => {
      try {
        const data = JSON.parse(message.toString());
        if (this.messageCallback) {
          this.messageCallback(topic, data);
        }
      } catch (error) {
        console.error('Error parseando mensaje MQTT:', error);
      }
    });

    this.client.on('error', (error) => {
      console.error('❌ Error MQTT:', error);
    });

    this.client.on('offline', () => {
      console.warn('⚠️  MQTT offline');
      this.connected = false;
      if (this.disconnectCallback) {
        this.disconnectCallback();
      }
    });

    this.client.on('reconnect', () => {
      console.log('🔄 Reconectando a MQTT...');
    });
  }

  disconnect() {
    if (this.client) {
      this.client.end();
      this.connected = false;
    }
  }

  publish(topic, message, options = {}) {
    if (this.client && this.connected) {
      this.client.publish(topic, JSON.stringify(message), {
        qos: options.qos || 1,
        retain: options.retain || false
      });
    }
  }

  subscribe(topic, callback) {
    if (this.client && this.connected) {
      this.client.subscribe(topic, { qos: 1 }, (err) => {
        if (!err && callback) {
          callback();
        }
      });
    }
  }

  onConnect(callback) {
    this.connectCallback = callback;
  }

  onDisconnect(callback) {
    this.disconnectCallback = callback;
  }
}

export const mqttService = new MqttService();
